"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailingListSignup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _formik = require("formik");

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _designSystem = require("@storybook/design-system");

var _useMailingListForm3 = require("./useMailingListForm");

var _excluded = ["handleBlur", "handleChange", "isSubmitting", "value", "placeholder"],
    _excluded2 = ["onSubscribe"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MailingListFormUIWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eevew1k4"
} : {
  target: "eevew1k4",
  label: "MailingListFormUIWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ho1qnd",
  styles: "display:flex;flex-direction:row"
} : {
  name: "ho1qnd",
  styles: "display:flex;flex-direction:row",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var EmailInput = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Input, process.env.NODE_ENV === "production" ? {
  target: "eevew1k3"
} : {
  target: "eevew1k3",
  label: "EmailInput"
})("flex:1;&& input{border-top-left-radius:", _designSystem.styles.spacing.borderRadius.small, "px;border-bottom-left-radius:", _designSystem.styles.spacing.borderRadius.small, "px;border-top-right-radius:0px;border-bottom-right-radius:0px;}");
var SendButton = (0, _theming.styled)("button", process.env.NODE_ENV === "production" ? {
  target: "eevew1k2"
} : {
  target: "eevew1k2",
  label: "SendButton"
})("border:0;border-radius:3em;cursor:pointer;display:inline-block;overflow:hidden;padding:13px 20px;position:relative;text-align:center;text-decoration:none;transition:all 150ms ease-out;user-select:none;opacity:1;margin:0;font-size:14px;font-weight:800;line-height:1;background:#1ea7fd;transform:translate3d(0, 0, 0);color:#fff;border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:", _designSystem.styles.spacing.borderRadius.small, "px;border-bottom-right-radius:", _designSystem.styles.spacing.borderRadius.small, "px;&:hover{background-color:rgb(5, 157, 253);transform:translate3d(0px, -2px, 0px);box-shadow:rgba(0, 0, 0, 0.2) 0px 2px 6px 0px;}&:active{transform:translate3d(0px, 0px, 0px);box-shadow:rgba(0, 0, 0, 0.1) 0px 0px 0px 3em inset;}");

var MailingListFormUI = function MailingListFormUI(_ref) {
  var handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      isSubmitting = _ref.isSubmitting,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Get news emailed to you' : _ref$placeholder,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var id = (0, _reactDomInteractions.useId)();
  return /*#__PURE__*/_react["default"].createElement(MailingListFormUIWrapper, rest, /*#__PURE__*/_react["default"].createElement(EmailInput, {
    id: id,
    icon: "email",
    type: "email",
    name: "email",
    value: value,
    placeholder: placeholder,
    onChange: handleChange,
    onBlur: handleBlur,
    autoCapitalize: "off",
    autoCorrect: "off",
    label: "Your email",
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement(SendButton, {
    type: "submit"
  }, "Subscribe"));
};

var MailingListConfirm = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eevew1k1"
} : {
  target: "eevew1k1",
  label: "MailingListConfirm"
})("font-size:", _designSystem.styles.typography.size.s2, "px;background:", _designSystem.styles.background.positive, ";line-height:20px;padding:10px;text-align:center;border-radius:", _designSystem.styles.spacing.borderRadius.small, "px;position:absolute;top:0;right:0;bottom:0;left:0;z-index:4;");
var FormWrapper = (0, _theming.styled)("form", process.env.NODE_ENV === "production" ? {
  target: "eevew1k0"
} : {
  target: "eevew1k0",
  label: "FormWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "3be6sz",
  styles: "max-width:320px;position:relative"
} : {
  name: "3be6sz",
  styles: "max-width:320px;position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var validateForm = function validateForm(values) {
  if (!values.email) {
    return {
      email: 'Required'
    };
  }

  return {};
};

var MailingListSignup = function MailingListSignup(_ref2) {
  var onSubscribe = _ref2.onSubscribe,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var formRef = (0, _react.useRef)(null);

  var _useMailingListForm = (0, _useMailingListForm3.useMailingListForm)(onSubscribe),
      _useMailingListForm2 = (0, _slicedToArray2["default"])(_useMailingListForm, 2),
      hasSubmitted = _useMailingListForm2[0],
      onSubmitForm = _useMailingListForm2[1];

  (0, _react.useEffect)(function () {
    if (hasSubmitted && formRef.current) {
      var submitButtonEl = formRef.current.querySelector('[type="submit"]');

      if (submitButtonEl) {
        submitButtonEl.blur();
      }
    }
  }, [formRef, hasSubmitted]);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: ''
    },
    validate: validateForm,
    onSubmit: onSubmitForm
  }, function (_ref3) {
    var values = _ref3.values,
        handleChange = _ref3.handleChange,
        handleBlur = _ref3.handleBlur,
        handleSubmit = _ref3.handleSubmit,
        isSubmitting = _ref3.isSubmitting;
    return /*#__PURE__*/_react["default"].createElement(FormWrapper, {
      ref: formRef,
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(MailingListFormUI, (0, _extends2["default"])({
      value: values.email,
      handleChange: handleChange,
      handleBlur: handleBlur,
      isSubmitting: isSubmitting
    }, props)), hasSubmitted && /*#__PURE__*/_react["default"].createElement(MailingListConfirm, {
      role: "alert"
    }, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "thumbs up"
    }, "\uD83D\uDC4D"), ' ', "Thanks, you\u2019re all signed up!")));
  });
};

exports.MailingListSignup = MailingListSignup;